import { eventGetters } from './eventGetters'
import type {
  EventAddOn,
  EventDate,
  EventDescription,
} from '~/composables/types/event'
import { EventDateCartItem } from '~/composables/types/cart'

const parseEventDateToCartItem = (
  event: EventDescription,
  selectedTicketQuantity: Ref<number | undefined> | number,
  selectedTime?: Ref<EventDate>,
  selectedAddOn: Ref<EventAddOn | undefined>,
  isPrivate = false,
  queryId = ''
): EventDateCartItem => {
  const privateMaxTickets = eventDateGetters.getPrivateMaxTickets(
    selectedTime.value
  )
  const publicMaxTickets = eventDateGetters.getAvailableTicketsQuantity(
    selectedTime.value
  )

  const availableTickets = isPrivate ? privateMaxTickets : publicMaxTickets

  const qty = Math.min(toValue(selectedTicketQuantity) || 1, availableTickets)

  return {
    type: 'EVENT',
    id: selectedTime.value.id,
    children: selectedTime?.value?.children || [],
    quantity: qty,
    eventDescriptionId: eventGetters.getId(event),
    title: eventGetters.getTitle(event),
    category: eventGetters.getMainCategory(event) || '',
    permalink: eventGetters.getPermalink(event),
    thumbnail: imageGetters.getThumb(eventGetters.getPrincipalImage(event)),
    requiredAddress: eventGetters.getIsAddressRequired(event) || false,
    price: eventDateGetters.getPrice(selectedTime.value) || undefined,
    availableTicketsQuantity: eventDateGetters.getAvailableTicketsQuantity(
      selectedTime.value
    ),
    privateMinTickets: eventDateGetters.getPrivateMinTickets(
      selectedTime.value
    ),
    privateMaxTickets,
    dateType: eventDateGetters.getDateType(selectedTime.value) || undefined,
    date: eventDateGetters.getStartTime(selectedTime.value),
    startTime: eventDateGetters.getStartTime(selectedTime.value),
    endTime: eventDateGetters.getEndTime(selectedTime.value),
    private:
      isPrivate ||
      eventDateGetters.getIsPrivate(selectedTime.value, true) ||
      false,
    dateTypeToBeBooked: isPrivate ? 'PRIVATE' : 'PUBLIC',
    addOn: selectedAddOn.value,
    queryID: queryId,
    attendanceMode: eventGetters.getAttendanceMode(event),
    hasShippingCosts: eventGetters.hasShippingCosts(event),
    supplier: eventGetters.getSupplierName(event),
    needsMajority: eventGetters.getNeedsMajority(event),
    originalPrice:
      eventDateGetters.getOriginalPrice(selectedTime.value) ||
      eventGetters.getOriginalPrice(event),
  }
}

export default parseEventDateToCartItem
